module.exports = __webpack_public_path__ + "media/images/new_home/sponsor-logo-1-4baef8025ad932297c2a1d3fea361392.png";